import { apiCall } from "../helpers/api";

export const report =
    (params = {}) =>
    (dispatch) => {
        params.path = params.path || "report";
        return dispatch(apiCall(params));
    };
